import { render, staticRenderFns } from "./AccreditationListsIcon.vue?vue&type=template&id=31c8a3e2&scoped=true&"
import script from "./AccreditationListsIcon.vue?vue&type=script&lang=js&"
export * from "./AccreditationListsIcon.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationListsIcon.vue?vue&type=style&index=0&id=31c8a3e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8a3e2",
  null
  
)

export default component.exports